var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-status-tag-comp",class:[_vm.progress, _vm.type]},[(_vm.type === 'point')?_c('div',{staticClass:"flag"}):_vm._e(),_vm._v(" "+_vm._s(_vm.progressLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }